import React from 'react'
import BillingView from '../containers/Billing/View/BillingView'
import Header from '../components/Header/Header' 
import SidebarPage from '../components/Sidebar/Sidebar'
import { MainContainer } from '../components/common/Containers' 
 
const Parcels = () => {
    return ( 
        <>  
            <SidebarPage />
            <MainContainer>    
                <Header /> 
                <main> 
                    <BillingView/>  
                </main> 
            </MainContainer>
        </>
    )
}

export default Parcels
